/* Nesti — carrossel de avaliações: laço infinito (como o slick da referência), setas, arrasto, Read more */
(function () {
  function porTela() { return innerWidth < 750 ? 1 : innerWidth < 990 ? 2 : 3; }
  function iniciar(raiz) {
    if (raiz.dataset.pronto) return; raiz.dataset.pronto = '1';
    var trilho = raiz.querySelector('.nesti-lai__trilho');
    var slides = Array.prototype.slice.call(trilho.children);
    var n = slides.length, atual = 0;
    function ir(i) {
      var pt = porTela();
      var fim = Math.max(0, n - pt);
      if (i < 0) i = fim; if (i > fim) i = 0;
      atual = i;
      trilho.style.transform = 'translateX(' + (-100 / pt * atual) + '%)';
      trilho.style.transform = 'translateX(-' + (slides[0].getBoundingClientRect().width * atual) + 'px)';
    }
    raiz.querySelector('.nesti-lai__seta--esq').addEventListener('click', function () { ir(atual - 1); });
    raiz.querySelector('.nesti-lai__seta--dir').addEventListener('click', function () { ir(atual + 1); });
    raiz.querySelectorAll('.nesti-lai__seta').forEach(function (s) {
      s.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); s.dispatchEvent(new Event('click')); } });
    });
    var x0 = null;
    trilho.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    trilho.addEventListener('touchend', function (e) {
      if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) ir(atual + (dx < 0 ? 1 : -1));
    });
    raiz.addEventListener('click', function (e) {
      var mais = e.target.closest('.nesti-lai__mais');
      if (mais) {
        var item = mais.closest('.nesti-lai__item');
        item.querySelector('.nesti-lai__texto--curto').hidden = true;
        item.querySelector('.nesti-lai__texto--longo').hidden = false;
        return;
      }
      var th = e.target.closest('.nesti-lai__thumb');
      if (th) {
        var cam = document.createElement('div'); cam.className = 'nesti-lai-foto';
        var img = document.createElement('img'); img.src = th.querySelector('img').src.replace(/width=\d+/, 'width=1600'); img.alt = '';
        cam.appendChild(img); cam.addEventListener('click', function () { cam.remove(); });
        document.addEventListener('keydown', function f(k) { if (k.key === 'Escape') { cam.remove(); document.removeEventListener('keydown', f); } });
        document.body.appendChild(cam);
      }
    });
    raiz.addEventListener('keydown', function (e) { if ((e.key === 'Enter' || e.key === ' ') && e.target.classList.contains('nesti-lai__mais')) { e.preventDefault(); e.target.click(); } });
    window.addEventListener('resize', function () { ir(atual); });
    ir(0);
  }
  function tudo() { document.querySelectorAll('[data-nesti-lai]').forEach(iniciar); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tudo); else tudo();
  document.addEventListener('shopify:section:load', tudo);
})();
